import React, {ReactElement, ReactNode} from 'react';
import { CssBaseline, Container, Snackbar, Switch, FormGroup, FormControlLabel } from '@mui/material';
import NavContainer from '../Navigation/NavContainer';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { amber, deepOrange, grey } from '@mui/material/colors';
import { PaletteMode } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { selectThemeMode, ToggleThemeMode } from '../../state/reducers/UserSettingsReducer';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

export interface Props {
    children:  ReactElement | ReactNode;
}


const PrimaryColorPallette = {
  light: '#21ace1',
  main: '#21ace1',
  dark: '#21ace1',
  contrastText: '#21ace1',
}


const getDesignTokens = (mode: PaletteMode) => ({
    palette: {
      mode,
      primary: {
        ...PrimaryColorPallette,
        ...(mode === 'dark' && {
          //main: amber[300],
        }),
      },
      ...(mode === 'dark' && {
        background: {
          //default: deepOrange[900],
          //paper: deepOrange[900],
        },
      }),
      text: {
        ...(mode === 'light'
          ? {
             // primary: grey[900],
              //secondary: grey[800],
            }
          : {
              //primary: '#fff',
              //secondary: grey[500],
            }),
      },
    },
  });

const Theme = ({children}) => {
    const themeMode = useAppSelector(selectThemeMode);
    const theTheme = createTheme(getDesignTokens(themeMode));
  
    return (<div>
        <ThemeProvider theme={theTheme}>
          <div className={`root-container theme-${themeMode}`}>
            <CssBaseline />
            <NavContainer />
                {children}
            <Footer />
          </div>
        </ThemeProvider>
    </div>)
} 

export default Theme;   